export default __webpack_public_path__ + "static/media/card2-2.f5ee25df.jpg";